module.exports = __webpack_public_path__ + "media/images/spree/frontend/credit_cards/discover_cid-1eae1e368eaad27aefa12fe1e273604f.gif";